import Carousel from './Carousel';
import Slider from './Slider';

/**
 * Simple factory for creating different types of maps
 */
export default class SliderFactory {
  static initialize(el, options) {
    switch (options['design']) {
      case 'carousel':
        return new Carousel(el, options);
      default:
        return new Slider(el, options);
    }
  }
}
